import * as React from "react";

export const useWindowLocation = (): Location | undefined => {
  const isMountedRef = React.useRef(false);

  React.useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const [location, setLocation] = React.useState<Location | undefined>(
    isMountedRef.current ? window.location : undefined
  );

  React.useEffect(() => {
    if (!isMountedRef.current) return;

    const setWindowLocation = () => {
      setLocation(window.location);
    };

    if (!location) {
      setWindowLocation();
    }

    window.addEventListener("popstate", setWindowLocation);

    return () => {
      window.removeEventListener("popstate", setWindowLocation);
    };
  }, [isMountedRef, location]);

  return location;
};
